<template>
	<WelcomePage />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const WelcomePage = defineAsyncComponent(
	() => import('@/pages/welcome/WelcomePage.vue')
);
</script>
